import React from 'react';
import Downshift from 'downshift';
import get from 'lodash.get';

import { Box, TextInput } from '@neta';
import SelectItems from './SelectItems';
import theme, { colors } from '@styles/theme';

const defaultShowOptions = value => !!value;
const itemToString = item => get(item, 'value');
const filterOptions = (options, value) => {
  const regex = new RegExp(value, 'i');
  return options.filter(({ name }) => regex.test(name));
};

export default class Autocomplete extends React.Component {
  state = { isOpen: this.props.isOpen };

  onFocus = () => this.setState({ isOpen: true });
  onBlur = () => this.setState({ isOpen: false });

  render() {
    const {
      newStyle,
      autoFocus,
      dontFilterOptions,
      error,
      extraTopContent,
      groupTitles,
      inputRef,
      inputType = 'search',
      onChange,
      onInputClick,
      onEnter,
      onSelect,
      options,
      placeholder,
      showOptions = defaultShowOptions,
      value = '',
      textStyle = 'caption'
    } = this.props;

    const { isOpen } = this.state;

    const filteredOptions = dontFilterOptions ? options : filterOptions(options, value);
    const unGroupedOptions = [].concat(...options);
    const showingValues = isOpen && showOptions(value);
    const containerStyles = showingValues
      ? {
          backgroundColor: newStyle ? 'transparent' : colors.grayscale.white,
          borderTop: newStyle ? 'none' : theme.borders.divider,
          borderLeft: newStyle ? 'none' : theme.borders.divider,
          borderRight: newStyle ? 'none' : theme.borders.divider,
          borderRadius: 4,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          margin: -4
        }
      : {
          borderTop: '1px solid transparent',
          borderLeft: '1px solid transparent',
          borderRight: '1px solid transparent',
          margin: -4
        };

    return (
      <Downshift
        onChange={onSelect}
        isOpen={isOpen}
        defaultHighlightedIndex={0}
        itemToString={itemToString}
      >
        {({
          getInputProps,
          getItemProps,
          highlightedIndex,
          inputValue,
          selectedItem
        }) => (
          <div style={containerStyles}>
            <Box p={1}>
              {extraTopContent}
              <TextInput
                {...getInputProps({
                  onChange,
                  onClick: onInputClick,
                  onFocus: this.onFocus,
                  onBlur: this.onBlur
                })}
                autoFocus={autoFocus}
                error={error}
                newStyle={newStyle}
                inputRef={inputRef}
                type={inputType}
                onEnter={onEnter}
                value={get(value, 'name', value)}
                placeholder={placeholder}
                textStyle={textStyle}
              />
            </Box>
            {showingValues && (
              <SelectItems
                bg={newStyle && colors.lightestPrimary}
                forAutocomplete
                getItemProps={getItemProps}
                groupTitles={groupTitles}
                highlightedIndex={highlightedIndex}
                options={filteredOptions}
                selectedItem={selectedItem}
                unGroupedOptions={unGroupedOptions}
              />
            )}
          </div>
        )}
      </Downshift>
    );
  }
}
